export const settlementChildrenDTOFields = {
    child: 'child',
    lastName: 'lastName',
    firstName: 'firstName',
    mainGroup: 'mainGroup',
    id: 'id',
    settlementPeriodEnd: 'settlementPeriodEnd',
    stayGrossCost: 'stayGrossCost',
    mealGrossCost: 'mealGrossCost',
    lessonsGrossCost: 'lessonsGrossCost',
    additionalCostsGrossCost: 'additionalCostsGrossCost',
    balance: 'balance',
    totalGrossCost: 'totalGrossCost',
    institutionId: 'institutionId',
    verified: 'verified',
} as const;

export const settlementChildrenBillComponentDTOFields = {
    name: 'name',
    grossAmount: 'grossAmount',
    grossDiff: 'grossDiff',
    netAmount: 'netAmount',
    vatAmount: 'vatAmount',
    amountString: 'amountString',
    discountString: 'discountString',
    additionalComponents: 'additionalComponents',
    vatRate: 'vatRate',
    onInvoice: 'onInvoice',
};

export const settlementChildPaymentDTOFields = {
    id: 'id',
    childId: 'childId',
    institutionId: 'institutionId',
    amount: 'amount',
    category: 'category',
    type: 'type',
    dateTime: 'dateTime',
    relatedTransactionId: 'relatedTransactionId',
    source: 'source',
    description: 'description',
    paymentMethod: 'paymentMethod',
};
